import { useIntl } from "react-intl";

const CentralizedUserSubscriptions = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "jira-software-pricing.modal-content.centralized-user-subscriptions.title",
            defaultMessage: "Centralized user subscriptions"
        }),
        body: intl.formatMessage({
            id: "jira-software-pricing.modal-content.centralized-user-subscriptions.body",
            defaultMessage:
                'With centralized user subscriptions, you can give a user entry into all sites (also called "instances") with a single license. This is a subscription model.'
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default CentralizedUserSubscriptions;
